import { render, staticRenderFns } from "./Knowledges_portal.vue?vue&type=template&id=4701d32f&scoped=true&lang=pug"
import script from "./Knowledges_portal.vue?vue&type=script&lang=js"
export * from "./Knowledges_portal.vue?vue&type=script&lang=js"
import style0 from "./Knowledges_portal.vue?vue&type=style&index=0&id=4701d32f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701d32f",
  null
  
)

export default component.exports